import { render } from "./MFITTTrainList.vue?vue&type=template&id=5f99660b&scoped=true"
import script from "./MFITTTrainList.vue?vue&type=script&lang=js"
export * from "./MFITTTrainList.vue?vue&type=script&lang=js"

import "./MFITTTrainList.vue?vue&type=style&index=0&id=5f99660b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5f99660b"

export default script